import { FC, PropsWithChildren } from 'react';

export const FileUploadStatusMessageWrapper: FC<PropsWithChildren> = ({ children }) => {
  return <div className='grow content-center text-left'>{children}</div>;
};
